<template>
  <div class="pb-8">
    <base-section
      id="social"
      class="text-center"
      space="10"
    >
      <br></br>
      <base-section-heading
        color="primary"
        title="Future-Proof Assets"
      >
        <!-- Want to bring the future of production to your project? View a short demo of our capture technology! -->
      </base-section-heading>
    </base-section>
    <v-row class="text-center wrap">
      <v-col class="xs12 row wrap justify-center">
        <div class="video-responsive ">
            <iframe width="560" height="315" src="https://www.youtube.com/embed/XGComklWJOM" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  export default {
    name: 'Video',
    data: () => ({
    }),
  }
</script>
<style>
/* Set your aspect ratio */
.video-container {
  position: relative;
  overflow: hidden;
  height: 0;
  padding-bottom: 56.25%;
}

.video-container iframe,
.video-container embed {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  max-width: 100%;
}

/* And set the max-width of the parent element */
.video-wrap {
  width: 100%;
  max-width: 600px;
}
</style>
